
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FcmodalcardComponent } from './fcmodalcard.component';
import { FcmodallistComponent } from './fcmodallist.component';
import { FcmodallistdataComponent } from './fcmodallistdata.component';
import { FcmodallistsearchComponent } from './fcmodallistsearch.component';
import { FclayoutModule } from '../fclayout/index.module';
import { FctlbModule } from '../fctlb/index.module';
import { FcbasicModule } from '../fcbasic/index.module';
import { AgGridModule } from 'ag-grid-angular';
import { FcmodalinputComponent } from './fcmodalinput.component';
import { FcshareModule } from '../fcshare.modal';
import { FctlblistitemComponent } from '../fctlb/fctlblistitem.component';
@NgModule({
  imports: [
    FcshareModule,
    FclayoutModule,
    FcbasicModule,
    FctlbModule,
    AgGridModule.withComponents([FctlblistitemComponent])],
  exports: [
    FcmodalcardComponent,
    FcmodallistComponent,
    FcmodallistdataComponent,
    FcmodallistsearchComponent,
    FcmodalinputComponent
  ],
  declarations: [
    FcmodalcardComponent,
    FcmodallistComponent,
    FcmodallistdataComponent,
    FcmodallistsearchComponent,
    FcmodalinputComponent
  ],
  entryComponents: [
    FcmodalcardComponent,
    FcmodallistComponent,
    FcmodallistdataComponent,
    FcmodallistsearchComponent,
    FcmodalinputComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class FcmodalModule { }
